var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatePickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    clipPath: "url(#clip-calendar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21549",
    "data-name": "Group 21549",
    transform: "translate(0.265 0.265)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_2_",
    "data-name": "calendar(2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18546",
    "data-name": "Path 18546",
    d: "M11.734,1.052h-1.21V.421a.421.421,0,0,0-.842,0v.631H3.789V.421a.421.421,0,0,0-.842,0v.631H1.736A1.738,1.738,0,0,0,0,2.789v8.945a1.738,1.738,0,0,0,1.736,1.736h10a1.738,1.738,0,0,0,1.736-1.736V2.789A1.738,1.738,0,0,0,11.734,1.052Zm-10,.842h1.21v.421a.421.421,0,0,0,.842,0V1.894H9.682v.421a.421.421,0,0,0,.842,0V1.894h1.21a.9.9,0,0,1,.895.895v1H.842v-1A.9.9,0,0,1,1.736,1.894Zm10,10.734h-10a.9.9,0,0,1-.895-.895v-7.1H12.629v7.1A.9.9,0,0,1,11.734,12.629Z",
    fill: "#434343",
    stroke: "#434343",
    strokeWidth: 0.28
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24188",
    "data-name": "Rectangle 24188",
    width: 7,
    height: 1,
    rx: 0.5,
    transform: "translate(3.432 8)",
    fill: "#434343"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatePickerIcon);
export default __webpack_public_path__ + "static/media/date_picker_icon.cb8b871f9a032a2e2eaf48a1df685ba4.svg";
export { ForwardRef as ReactComponent };